module.exports = __webpack_public_path__ + "img/AI_2.0c8ab619.png";